import React, { useEffect, useState, useContext } from "react";
import { Card, Col, InputGroup, Row } from "react-bootstrap";
import ReactPlotly from "../common/ReactPlotly/ReactPlotly";
import { Link, useNavigate } from "react-router-dom";
import * as pageRoutes from "../../pageRoutes";
import { apiCall } from "../common/common.js";
import {
    assortmentPieBrandList,
    assortmentKpiApi,
} from "../common/constants.js";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import SideMenuCommonFilterLib from "../../contextApi/SideMenuCommonFilterLib";

const CategoryGraphPieChart = (props) => {
    const {
        data,
        currentCategory,
        currentRetailer,
    } = props;
    const navigate = useNavigate();

    const [plotlyData, setPlotlyData] = useState({});
    const [currentChartData, setCurrentChartData] = useState([]);
    const [currentBrand, setCurrentBrand] = useState("all");
    const [brandList, setBrandList] = useState([]);
    const [sideMenuCommonFilterLibContext, setSideMenuCommonFilterLibContext] = useContext(SideMenuCommonFilterLib);
    const barChartIndexes = {
        'productGapCount': 'Product Gaps',
        'productMatchedCount': 'Product Matched',
        'brandGapCount': 'Brand Gaps',
        'brandMatchedCount': 'Brand Matched',
        'bestSellerCount': 'Best Seller',
        'clusterGapCount': 'Cluster Gaps',
        'clusterMatchedCount': 'Clustur Matched',
        'ubrGapCount': 'UBR Gaps'
    };

    useEffect(() => {
        let newPlotlyData = {};
        let merch1Category1Lib = sideMenuCommonFilterLibContext.merch1Category1Lib;
        let retailerLib = sideMenuCommonFilterLibContext.retailerLib;
        let allPieChart = {};

        if (data && currentBrand == 'all') {
            let filterData = data.filter(dataSingle => {
                let returnItem = true;
                if (currentCategory != 'all') {
                    let merch1_category_level_1 = merch1Category1Lib[dataSingle.merch1_category_level_1_id];
                    if (merch1_category_level_1 != currentCategory) {
                        returnItem = false; 
                    }
                }
                if (currentRetailer != 'all') {
                    let retailer_label = retailerLib[dataSingle.source_id];
                    if (retailer_label != currentRetailer) {
                        returnItem = false;
                    }
                }
                return returnItem;
            });
            Object.keys(barChartIndexes).map(barChartIndex => {
                allPieChart[barChartIndex] = 0;
            });
            filterData.map(filterDataSingle => {
                Object.keys(barChartIndexes).map(barChartIndex => {
                    allPieChart[barChartIndex] += filterDataSingle[barChartIndex];
                });
            });
        }
        console.log('piechartdata', data, currentRetailer, currentCategory, allPieChart);
        setPlotlyData(allPieChart);
        if (data && currentBrand != 'all') {
            getSelectedBrandReport();
        }
    }, [data, currentRetailer, currentCategory, currentBrand]);

    useEffect(() => {
        setCurrentBrand("all");
    }, [currentRetailer]);

    useEffect(() => {
        if (currentCategory != 'all' && currentRetailer != 'all') {
            getBrandList();
        }
    }, [currentCategory, currentRetailer]);

    const getBrandList = () => {
        setBrandList([]);
        let postBody = {
            "filters": {
                "source": [currentRetailer]
            }
        };
        if (currentCategory != 'all') {
            postBody["filters"]["merch1_category_level_1"] = [currentCategory];
        }
        apiCall("POST", assortmentPieBrandList, {
      
        }, postBody)
        .then((response) => {
            if (response.data.data) {
                console.log('brandList', response.data.data);
                setBrandList(["all"].concat(response.data.data.normalised_brand));
            }
            //setLoading(false);
        })
        .catch((error) => {
            console.log("ERROR", error);
            //setLoading(false);
        });
    }

    const getSelectedBrandReport = () => {
        setPlotlyData([]);
        let postBody = {
            "groupBy": ["source_id"],
            "filters": {
                "source": [currentRetailer],
                "normalised_brand": [currentBrand]
            }
        };
        if (currentCategory != 'all') {
            postBody["filters"]["merch1_category_level_1"] = [currentCategory];
        }
        apiCall("POST", assortmentKpiApi, {
      
        }, postBody)
        .then((response) => {
            if (response.data.data) {
                console.log('response.data.data', response.data.data);
                let allPieChart = {};
                Object.keys(barChartIndexes).map(barChartIndex => {
                    allPieChart[barChartIndex] = 0;
                });
                response.data.data.grouped_kpi_data.map(filterDataSingle => {
                    Object.keys(barChartIndexes).map(barChartIndex => {
                        allPieChart[barChartIndex] += filterDataSingle[barChartIndex];
                    });
                });
                setPlotlyData(allPieChart);
            }
            //setLoading(false);
        })
        .catch((error) => {
            console.log("ERROR", error);
            //setLoading(false);
        });
    };

    useEffect(() => {
        if (Object.keys(plotlyData).length) {
            setCurrentChartData([{
                values: Object.values(plotlyData),
                labels: Object.values(barChartIndexes),
                marker: {
                    //colors: ["#1f77b4", "#ff7f0e", "#2ca02c"]
                },
                hole: .4,
                pull: [.3,.3,.3,.3,.3,.3,.3],
                type: 'pie'
            }]);
        }
    }, [plotlyData, currentCategory, currentRetailer]);

    const onHoverPlotly = (event) => {
        if (event.points.length) {
            let point = event.points[0];
            if (point.label && (point.label == 'Cluster Brand Gaps' || point.label == 'Cluster Product Gaps')) {
                event.event.path[0].style.cursor = 'pointer';
            } else {
                event.event.path[0].style.cursor = '';
            }
        }
    };

    const onClickPlotly = (event) => {
        //console.log('event', event);
        if (event.points.length) {
            let point = event.points[0];
            if (point.label) {
                console.log(`${currentRetailer} ${point.label}`);
                if (point.label == 'Cluster Product Gaps') {
                    navigate(pageRoutes.productGapsPage + "?retailer=" + currentRetailer + "&category=" + currentCategory);
                }
                if (point.label == 'Cluster Brand Gaps') {
                    navigate(pageRoutes.productGapsUniqueByRetailersPage + "?retailer=" + currentRetailer + "&category=" + currentCategory);
                }
            }
        }
    };

    const onChange = (item) => {
        setCurrentBrand(item.value);
    };

    const loadOptions = (inputValue, callbackLoadOptions) => {
        let filterBrands = [];
        brandList.map(brandListSingle => {
            if (brandListSingle.toLowerCase().includes(inputValue) && filterBrands.length <= 100) {
                filterBrands.push(brandListSingle);
            }
        });
        callbackLoadOptions(filterBrands.map(filterBrand => {
            return {
                label: filterBrand,
                value: filterBrand
            }
        }));
    };

    return (<>
        <ReactPlotly
            data={currentChartData}
            layout={{
                margin: {l: 0, r: 0, b: 0},
                title: {
                    font: {
                        size: 12
                    },
                    text: ((currentCategory == 'all') ? 'All Categories' : `Sub Category ${currentCategory}`) + " | " + ((currentRetailer == 'all') ? 'All Competitors' : `Competitor ${currentRetailer}`)
                }
            }}
            config={{responsive: true}}
            onClick={onClickPlotly}
            onHover={onHoverPlotly}
            style={{width: '100%', height: '90%'}}
        />
        {currentCategory != 'all' && currentRetailer != 'all' && (brandList.length > 0) && <InputGroup className="justify-content-sm-center">
            <InputGroup.Text>Brand</InputGroup.Text>
            <AsyncSelect 
                className="w-75"
                menuPlacement="top"
                cacheOptions
                defaultOptions
                placeholder="Type Brand Name"
                loadOptions={loadOptions}
                onChange={onChange}
                defaultValue={{
                    label: currentBrand,
                    value: currentBrand
                }}
                value={{
                    label: currentBrand,
                    value: currentBrand
                }}
            />
            {/*<Select
                name="brand"
                className="w-75"
                isMulti={false}
                isClearable={false}
                menuPlacement={"top"}
                defaultValue={{
                    label: currentBrand,
                    value: currentBrand
                }}
                value={{
                    label: currentBrand,
                    value: currentBrand
                }}
                options={brandList.map(brandListSingle => {
                    return {
                        label: brandListSingle,
                        value: brandListSingle
                    };
                })}
                onChange={onChange}
            />*/}
        </InputGroup>}
    </>);
};

export default CategoryGraphPieChart;